<template>
  <v-container>
    <h1 class="text-center text-uppercase">PURCHASE ORDER</h1>
    <v-row class="text-left">
      <v-col>
        <v-btn text @click="$router.replace('/STOREROOM')">STORE ROOM</v-btn>
      </v-col>
      <v-col cols="1">
        <v-btn icon @click="getVendors">
          <v-icon>mdi-sync</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      single-line
      hide-details
    ></v-text-field>
    <br />
    <v-data-table
      :headers="headers"
      :items="VENDORS"
      :search="search"
      :items-per-page="10"
      class="elevation-1"
    >
      <template v-slot:item.phone="{ item }">
        <p>{{ item.phone + (item.phone2 != null ? "/" + item.phone2 : "") }}</p>
      </template>
      <template v-slot:item.id="{ item }">
        <v-btn dark @click="getStock(item)">new stock</v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      search: "",
      tab1: true,
      tab2: false,
      invoiceNumber: "",
      indate: "",
      invoiceRate: 0,
      newStock: false,
      headers: [
        {
          text: "Vendor Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: "Phone",
          align: "start",
          sortable: false,
          value: "phone",
        },
        {
          text: "GSTIN",
          align: "start",
          sortable: false,
          value: "gstin",
        },
        {
          text: "Shop Address",
          align: "start",
          sortable: false,
          value: "address",
        },
        {
          text: "ACTIONS",
          align: "center",
          sortable: false,
          value: "id",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["VENDORS", "STOCKROOM"]),
  },
  activated() {
    this.getVendors();
  },
  methods: {
    ...mapActions(["GET_VENDORS"]),
    getVendors() {
      this.$store.commit("SET_LOADING", true);
      this.GET_VENDORS().then(() => {
        this.$store.commit("SET_LOADING", false);
      });
    },
    getStock(item) {
      let routeData = this.$router.resolve({
        name: "PURCHASE_ORDER_DETIALS",
        params: { id: item.id },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style>
</style>